// extracted by mini-css-extract-plugin
module.exports = {"topic":"gamerigscore_topic__1tA9A","btnrig":"gamerigscore_btnrig__2i5xZ"};